import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { HiOutlineLogout } from "react-icons/hi";
import { RxQuestionMarkCircled } from "react-icons/rx";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";
import logo from "../../assets/Sidebar/Logo.png";
import AdminSideBarHrLine from "../../assets/Sidebar/adminSideBarHrLine.svg";
import { useLogOut } from "../../hooks/useLogOut";

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen, Menus }) => {
  const location = useLocation();
  const [openMenuIndices, setOpenMenuIndices] = useState([]);
  const [selectedChildMenuIndex, setSelectedChildMenuIndex] = useState(null);
  const [smallScreen, setIsSmallScreen] = useState(window.innerWidth < 1280);
  const [isScreenHeightBelow664, setIsScreenHeightBelow664] = useState(
    window.innerHeight < 664
  );

  const [logOut] = useLogOut();

  const handleMenuClick = (index) => {
    const selectedMenu = Menus[index];
    if (selectedMenu.childs?.length > 0) {
      setOpenMenuIndices((prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index)
          : [...prev, index]
      );
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1280);
      setIsScreenHeightBelow664(window.innerHeight < 664);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // log out method
  const logOutMethod = () => {
    logOut();
  };

  const BottomMenus = [
    {
      title: "Privacy Policy",
      icon: <RxQuestionMarkCircled className="w-5 h-5" />,
      link: "/privacy-policy",
    },
    {
      title: "Logout",
      icon: <HiOutlineLogout className="w-5 h-5" />,
      // link: "/logout",
      method: logOutMethod,
    },
  ];

  return (
    <div className="h-screen min-h-[460px] bg-primary overflow-y-auto relative pr-[3px]">
      <aside
        style={{ minHeight: "454px" }}
        className={`h-screen w-full bg-primary text-white font-inter duration-300 transform ${
          smallScreen
            ? isSidebarOpen
              ? "translate-x-0"
              : "-translate-x-full"
            : "translate-x-0"
        }`}
      >
        {/* Logo Section */}
        <div className="text-white w-full flex flex-col pt-[23px] items-center justify-center">
          <div className="flex flex-row justify-center items-center ">
            <div className="text-white flex mt-[8px] justify-center sticky top-0 z-50">
              <img
                src={logo}
                alt="Main"
                className="ml-[12px] px-[8px] h-[40px] w-auto"
              />
            </div>
          </div>
          <img
            src={AdminSideBarHrLine}
            alt="Main"
            className="w-[224px] ml-4 mt-[24px]"
          />
        </div>

        {/* Main Menu */}
        <div
          className="w-full flex-grow overflow-y-auto overflow-x-hidden scrollbar-webkit "
          style={{ maxHeight: "calc(100vh - 226px)", paddingTop: "16px" }}
        >
          <ul className=" ">
            <span className="text-white text-xs ml-4">CLIENT PORTAL</span>
            {Menus.map((menu, index) => (
              <div key={index} className="relative w-fuLl ml-4 min-h-[40px] ">
                <Link
                  to={menu.link || "#"}
                  className="w-full"
                  onClick={() => {
                    if (!menu.childs?.length) {
                      setIsSidebarOpen(false);
                    }
                  }}
                >
                  <li
                    className={`px-[12px] py-[10px] m-auto  w-[208px] group flex items-center gap-x-3 mt-2 rounded-lg ${
                      location.pathname === menu.link
                        ? "bg-white text-blue-shades"
                        : "text-white"
                    } hover:bg-white hover:text-blue-shades`}
                    onClick={() => handleMenuClick(index)}
                  >
                    <span className="w-5 h-5">{menu.icon}</span>
                    <span className="font-medium w-full">{menu.title}</span>
                    {menu.childs?.length > 0 && (
                      <span className="">
                        {openMenuIndices.includes(index) ? (
                          <FaChevronUp />
                        ) : (
                          <FaChevronDown />
                        )}
                      </span>
                    )}
                  </li>
                </Link>
                {menu.childs?.length > 0 && openMenuIndices.includes(index) && (
                  <ul className=" space-y-1 w-[208px]">
                    {menu.childs.map((child, childIndex) => (
                      <Link
                        to={child.link || "#"}
                        key={childIndex}
                        onClick={() => setIsSidebarOpen(false)}
                      >
                        <li
                          className={`px-[40px] font-medium py-[10px] mx-2  w-[208px] group flex items-center gap-x-3 mt-2 rounded-lg ${
                            location.pathname === child.link
                              ? "bg-white text-blue-shades"
                              : "hover:bg-white hover:text-blue-shades text-white"
                          }`}
                        >
                          {child.title}
                        </li>
                      </Link>
                    ))}
                  </ul>
                )}
                {index === 7 && (
                  <>
                    <div className="w-[220px] h-[2px] my-4 bg-white rounded-full"></div>
                    <span className="text-xs text-white ">JOIN WITH US</span>
                  </>
                )}
                 {index === 1 && (
                  <>
                    <div className="w-[220px] h-[2px] my-4 bg-white rounded-full"></div>
                    <span className="text-xs text-white ">ORDERS</span>
                  </>
                )}
                 {index === 5 && (
                  <>
                    <div className="w-[220px] h-[2px] my-4 bg-white rounded-full"></div>
                    <span className="text-xs text-white ">PROFILE PORTAL</span>
                  </>
                )}
              </div>
            ))}
          </ul>
        </div>

        {/* Bottom Menus */}
        <div
          className={` mt-auto items-center ${
            isScreenHeightBelow664
              ? "mb-auto ml-[20px]"
              : "absolute bottom-4 left-[24px]"
          }`}
        >
          <ul className="w-full mt-2">
            {BottomMenus.map((menu, index) => (
              <Link
                to={menu.link}
                key={index}
                onClick={() => {
                  if (!menu.link && menu.method) {
                    menu.method();
                  }
                }}
              >
                <li
                  className={`px-[12px] py-[10px] mb-2  w-[208px] flex items-center gap-x-3 rounded-lg font-medium hover:bg-white ${
                    menu.title === "Logout"
                      ? "text-light-red hover:text-light-red"
                      : "text-white hover:text-blue-shades"
                  }`}
                >
                  <span>{menu.icon}</span>
                  <span>{menu.title}</span>
                </li>
              </Link>
            ))}
          </ul>
        </div>
      </aside>

      {/* Close Button for mobile screens */}
      {smallScreen && (
        <button
          onClick={() => setIsSidebarOpen(false)}
          className="absolute top-4 right-4 xl:hidden text-white text-2xl"
        >
          &times;
        </button>
      )}

      {/* Overlay */}
      {smallScreen && isSidebarOpen && (
        <div
          onClick={() => setIsSidebarOpen(false)}
          className="fixed inset-0 bg-black opacity-50"
          style={{
            clipPath: `inset(0 0 0 ${isSidebarOpen ? "256px" : "0px"})`,
          }}
        ></div>
      )}
    </div>
  );
};

export default Sidebar;
